import React from 'react'
import { Header, Hero, CreateJob } from '../components'

const Home = () => {
  return (
    <div>
      <Header />
      <Hero />
      <CreateJob />
    </div>
  )
}

export default Home
